<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { SmartmodelMessage } from './types/smartmodel-message';

  export let buildings: string[] = [];

  const dispatch = createEventDispatcher<{ navigate: SmartmodelMessage }>();

  const handleToPztClick = () => {
    dispatch('navigate', {receiver: 'router', data: '/'});
  };

  const handleBuildingClick = (path: string) => {
    dispatch('navigate', {receiver: 'router', data: '/building/' + path});
  };
</script>

<div class="container-fluid">
  <div class="row">
    <div class="col-auto">
      <button class="btn btn-primary" on:click="{() => handleToPztClick()}">Do PZT</button>
    </div>
    {#each buildings as building}
      <div class="col-auto">
        <button class="btn btn-primary" on:click="{() => handleBuildingClick(building)}">Budynek {building}</button>
      </div>
    {/each}
  </div>
</div>
